module.exports = __webpack_public_path__ + "static/media/nz.6bb1f1bd.svg";


//////////////////
// WEBPACK FOOTER
// ./~/react-flags-select/flags/nz.svg
// module id = 952
// module chunks = 0